import $ from './helpers/legacy/jquery';

import 'jquery-ui/ui/version';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/unique-id';
import 'jquery-ui/ui/plugin';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/accordion';

import './modules/sondernutzungsassistent/accordion';

// UL Sortierfunktion
$.fn.sortList = function () {
	if (!$(this).is('ul')) return false;

	const ul = $(this);

	const lis = ul.children().sort((a, b) => {
		const aVal = $(a).text().toLowerCase();
		const bVal = $(b).text().toLowerCase();
		return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
	});

	return ul.empty().append(lis);
};

// Liste sortieren
$('ul.sort').sortList();

// Allgemeine Variablen
const sSelector = '.bs-accordion.bs-sondernutzung'; // Selektor
let assistantCompleted = false;

let inside;
let outside;
let active;

// Sheet Aktivierungs-Funktion
function activateSheet(nr) {
	$(sSelector + ' header:eq(' + nr + ')').removeClass('ui-state-disabled'); // Aktivieren
	$(sSelector).accordion('option', 'active', nr); // Oeffnen

	// Runterscrollen abnehmen
	// var offset = $(sSelector + ' header:eq(' + nr + ')').offset();
	// $("html,body").delay(100).animate({'scrollTop':offset.top},"slow");
}

function showResult() {
	// Alle verstecken
	$(sSelector + ' #section-ansprechpartner div.ansprechpartner')
		.addClass('hidden')
		.removeClass('active');

	// Ergebnis anzeigen
	if (active === 'inside') {
		$(sSelector + ' #section-ansprechpartner div.ansprechpartner#' + inside)
			.removeClass('hidden')
			.addClass('active');
	} else {
		$(
			sSelector +
				' #section-ansprechpartner div.ansprechpartner#' +
				outside
		)
			.removeClass('hidden')
			.addClass('active');
	}
}

// Accordion initalisieren
$(sSelector).accordion('option', 'collapsible', false); // Einer muss immer offen sein
$(sSelector).accordion('option', 'active', 0); // Den ersten aktivieren

$(sSelector + ' #sondernutzung-auswahl #auswahl-anliegen').click(() => {
	activateSheet(0);
});
$(sSelector + ' #sondernutzung-auswahl #auswahl-bereich').click(() => {
	activateSheet(1);
});

// Anliegen Auswahl Event
$(sSelector + ' #section-anliegen li').on('click', function () {
	// Auswahl hervorheben
	$(sSelector + ' #section-anliegen li.active').removeClass('active');
	$(this).addClass('active');

	// Auswahl speichern
	inside = $(this).data('inside');
	outside = $(this).data('outside');
	active = 'default';

	// Karte zurücksetzen
	$(sSelector + ' #section-bereich div.bereich-map > img')
		.addClass('hidden')
		.removeClass('active');
	$(sSelector + ' #section-bereich div.bereich-map > img.default')
		.addClass('active')
		.removeClass('hidden');
	$(sSelector + ' #section-bereich a.active').removeClass('active');

	// Auswahl darstellen
	$(sSelector + ' #sondernutzung-auswahl #auswahl-anliegen').text(
		$(sSelector + ' #section-anliegen li.active').text()
	);

	if (assistantCompleted) {
		showResult();
	}

	// Nächste Aktion
	/* activateSheet(assistantCompleted?2:1);  skip step two after first round*/
	activateSheet(1);
	return false;
});

// Bereich Auswahl - Buttons
$(sSelector + ' #section-bereich .bereich-buttons > a').on(
	'click',
	function () {
		// Auswahl hervorheben
		$(sSelector + ' #section-bereich a.active').removeClass('active');
		$(this).addClass('active');

		// Ergebnis anzeigen
		if ($(this).hasClass('bereich-inside')) {
			active = 'inside';
		} else if ($(this).hasClass('bereich-outside')) {
			active = 'outside';
		}

		// Auswahl darstellen
		$(sSelector + ' #sondernutzung-auswahl #auswahl-bereich').text(
			$(this).text()
		);

		assistantCompleted = true;

		if (assistantCompleted) {
			showResult();
		}

		// Nächste Aktion anzeigen (Ansprechpartner)
		activateSheet(2);
		return false;
	}
);

// Bereich Auswahl - Buttons Hover
$(sSelector + ' #section-bereich .bereich-buttons > a')
	.on('mouseenter touchstart', function () {
		// Alle verstecken
		$(sSelector + ' #section-bereich div.bereich-map > img')
			.addClass('hidden')
			.removeClass('active');

		// Ergebnis anzeigen
		if ($(this).hasClass('bereich-inside')) {
			$(sSelector + ' #section-bereich div.bereich-map > img.inside')
				.removeClass('hidden')
				.addClass('active');
		} else if ($(this).hasClass('bereich-outside')) {
			$(sSelector + ' #section-bereich div.bereich-map > img.outside')
				.removeClass('hidden')
				.addClass('active');
		}
	})
	.on('mouseleave touchend', () => {
		// Alle verstecken
		$(sSelector + ' #section-bereich div.bereich-map > img')
			.addClass('hidden')
			.removeClass('active');
		$(sSelector + ' #section-bereich div.bereich-map > img.' + active)
			.addClass('active')
			.removeClass('hidden');
	});
